import usePlaylistsData from "@hooks/game/playlists/use-playlists-data";
import { PlaylistResponse } from "@Shared/schemas/playlists/playlistSchemas";
import React, { createContext, useContext } from "react";

type Playlist = PlaylistResponse;

type PlaylistsContextType = {
  playlists: Playlist[] | null;
  loading: boolean;
};

export const PlaylistsContext = createContext<PlaylistsContextType>({
  playlists: null,
  loading: true,
});

export const PlaylistsProvider = ({ children }: { children: React.ReactNode }) => {
  const { playlists, loading } = usePlaylistsData();

  return <PlaylistsContext.Provider value={{ playlists, loading }}>{children}</PlaylistsContext.Provider>;
};

export const usePlaylistsContext = () => {
  const context = useContext(PlaylistsContext);
  if (context === undefined) {
    throw new Error("usePlaylistsContext must be used within a PlaylistsProvider");
  }
  return context;
};
